import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LocalizationModule } from '@abp/ng.core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ErrorFormControlDirective, LoadingService } from '@digiwall/core';
import { DayBookDto, DayBookService, SupplierPreparationService } from '@digiwall/goliath-documents/proxy';
import { DocRole } from '@digiwall/goliath-core/proxy';
import { DialogBoxComponent } from '@digiwall/ui-kit';

@Component({
  selector: 'document-generate-reception-dialog',
  templateUrl: './generate-reception-dialog.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LocalizationModule,
    NgSelectModule,
    DialogBoxComponent,
    ErrorFormControlDirective,
  ],
})
export class GenerateReceptionDialogComponent implements OnInit {
  public preparationId!: string;

  protected form: FormGroup;
  protected dayBooks = signal<DayBookDto[]>([]);
  protected isSaving = signal(false);

  private readonly offcanvas = inject(NgbActiveOffcanvas);
  private readonly dayBookService = inject(DayBookService);
  private readonly docService = inject(SupplierPreparationService);
  private readonly loadingService = inject(LoadingService);
  private readonly fb = inject(FormBuilder);

  ngOnInit(): void {
    this.form = this.fb.group({
      dayBookId: [null, Validators.required],
    });
    this.loadDaybooks();
  }

  private loadDaybooks(): void {
    this.dayBookService.getDayBooksByRole(DocRole.SupplierDeliveryNote).subscribeOnce(daybooks => {
      this.dayBooks.set(daybooks);
      if (daybooks.length > 0 && !this.form.get('dayBookId')!.value) {
        this.form.get('dayBookId')!.setValue(daybooks[0].id);
      }
    });
  }

  protected generate(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSaving.set(true);
    this.loadingService.interceptNextRequest();

    this.docService
      .generateReception(this.preparationId, { dayBookId: this.form.get('dayBookId')!.value })
      .subscribeOnce(
        result => {
          this.offcanvas.close({ type: 'success', displayNumber: result.result });
        },
        err => {
          if (err?.error?.code === 'GoliathDocuments:SupplierPreparationNoPreparedLines') {
            this.offcanvas.close({ type: 'noPreparedLines' });
          } else {
            this.isSaving.set(false);
          }
        },
      );
  }

}
